const globals = {
  getImageSize: () => {
    throw new Error('getImageSize() is not defined');
  }
};

export default globals;
